/**
 * The section's ONE password generator, used by the create form (its prefilled value) and by the
 * mock service's simulated rotations. There is no other: two generators drift, and the weaker one
 * is the one that gets called.
 *
 * Generated in the browser on purpose. The service returns the plaintext in the create response
 * anyway, so it lands here and is shown either way; generating it first costs nothing and lets the
 * operator see (and copy) the password before committing to it.
 *
 * Strength is OURS to guarantee. Because a strong password is always sent, the provider's own
 * strength rules stop mattering to us, which is just as well: it accepted `123456789A`, so they
 * cannot be relied on.
 */

/** No ambiguous characters (no 0/O, no 1/l/I): the password is meant to be retyped into a client. */
const ALPHABET = 'abcdefghijkmnpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ23456789';
const GROUPS = 3;
const GROUP_LENGTH = 4;

/**
 * A readable, strong password: three dash-separated groups of four (about 70 bits). Drawn from the
 * platform's cryptographic source, never the Math PRNG, whose state is recoverable from a few
 * outputs. The modulo bias over 2^32 is negligible for a 56-character alphabet.
 */
export const generateMailboxPassword = (): string => {
  const values = crypto.getRandomValues(new Uint32Array(GROUPS * GROUP_LENGTH));
  const chars = Array.from(values, (n) => ALPHABET[n % ALPHABET.length]);
  return Array.from({ length: GROUPS }, (_, g) => chars.slice(g * GROUP_LENGTH, (g + 1) * GROUP_LENGTH).join('')).join(
    '-',
  );
};
